export default {
  welcome: 'Welcome',
  language: 'Language',
  loading: 'Loading...',
  sidebar: {
    navigation: 'Main navigation',
    collapse: 'Collapse sidebar',
    expand: 'Expand sidebar',
  },
  company: {
    name: CONFIG.COMPANY_NAME_EN,
    app_title: CONFIG.APP_TITLE_EN,
  },
  menu: {
    dashboard: 'Dashboard',
    product: 'Product',
    form: 'Form',
    addProduct: 'add product',
    ProductManage: 'Product Manage',
    campaign: 'campaign',
    newBundle: 'create a new package',
    BoxManage: 'manage packages',
    addCampaign: 'create  campaign',
    campaignManage: 'campaign management',
    editCampaign: 'edit campaign',
    mission: 'missions',
    misstionList: 'misstion List',
    missionManage: 'mission Manage',
    scoreCampaign: 'points campaign',
    codeBaseCampaign: 'code base campaign',
    tieredPointsCampaign: 'tiered Points Campaign',
    users: 'users',
    financialReports: 'financial Reports',
    financialTransactions: 'financial Transactions',
    factors: 'factors',
    store: 'store',
    listOfStoreProducts: 'list Of Store Products',
    createNewProduct: 'create a New Product',
    brands: 'brands',
    categoryOfGoods: 'category Of Goods',
    orders: 'orders',
    addGiftProduct: 'Create gift product',
    registeredOrders: 'registered Orders',
    abandonedShoppingCart: 'abandoned Shopping Cart',
    paymentOfOrders: 'payment Of Orders',
    discountCodes: 'discount Codes',
    insert_invoice: 'Insert Invoice',
    notificationOfCampaigns: 'notification Of Campaigns',
    gifts: 'Gifts',
    uploadVoucher: 'Add Voucher Codes',
    voucherStock: 'Voucher Stock',
    giftCategories: 'Gift Categories',
    giftProducts: 'Gift Items',
    invoices: 'Invoices',
    selledVouchers: 'Selled Vouchers',
    scoreRecords: 'Earned Scores',
    reports: 'Reports',
    grades: 'Customer Grades',
    cities: 'Cities',
    basicData: 'Basic Data',
    report: 'Report',
    spins: 'Spin Results',
    spinners: 'Spinners',
    spinnersList: 'Spinners List',
    spinnerItems: 'Spinner Items',
    addSpinner: 'Create Spinner',
    SimCharge: 'Sim Card',
    SimChargeReport: 'Sim Card Report',
    ScoreRatio: 'Score / Rial ',
    voucherManagement: 'Voucher Management',
    uploadInvoice: 'Upload Invoice',
    // titles for routes outside the sidebar menu (route meta.title)
    notFound: 'Page Not Found',
    editForm: 'Edit Form',
    adminForm: 'Admin Form',
    adminEditForm: 'Edit Admin Form',
    ticketDetail: 'Ticket Details',
    editInvoice: 'Edit Invoice',
    editSurvey: 'Edit Survey',
    surveyAnalytics: 'Survey Analytics',
    editProduct: 'Edit Product',
    addSurvey: 'Create Survey',
    medals: 'Medals',
    addGrade: 'Add grade',
    addMedal: 'Add medal',
    addContent: 'Add content section',
    addContactInfo: 'Add contact info',
    addCategory: 'Add category',
    addBanner: 'Add home banner',
    homeShortcuts: 'Home shortcuts',
    editBanner: 'Edit banner',
    editCategory: 'Edit category',
    editGrade: 'Edit grade',
    editMedal: 'Edit medal',
    editContent: 'Edit content section',
    editContactInfo: 'Edit contact info',
    addNotification: 'Send notification',
    addStore: 'Add store',
    addGift: 'Add gift',
    voucherStorage: 'Voucher storage',
    vouchersUsed: 'Used vouchers',
    invoiceReview: 'Invoice Review',
    pageBuilder: 'Page Builder',
    ratioCoin: 'Points Rate Conversion',
    docs: 'Docs',
    generateVoucher: 'Generate Vouchers',
    importMobile: 'Import Mobile Numbers',
    codes: 'Import Codes',
    userCredit: 'User Credit',
    generatePasskeys: 'Generate Passkeys',
    addMission: 'Add Mission',
    editMission: 'Edit Mission',
  },
  datetime: {
    today: 'Today is {date}',
    current: 'Current time is {time}',
  },
  validation: {
    minDynamic: 'The value must be greater than or equal to {min}',
    maxDynamic: 'The value must be less than or equal to {max}',
    rangeDynamic: 'The value must be between {min} and {max}',
    mobile: 'The entered value is incorrect',
    username: 'Username is required',
    openError: 'Error in login',
    passowrdError: 'Username or password is incorrect',
    password: 'Password is required',
    usernameMin: 'Username must be at least 3 characters',
    usernameMax: 'Username cannot be longer than 50 characters',
    passwordMin: 'Password must be at least 6 characters long',
    logoutSuccess: 'Logout Successful',
    logoutMessage: 'You have been logged out successfully',
    passwordMax: 'Password cannot be longer than 20 characters',
    changePassword: {
      placeholderCurrentPass: 'Please enter your current password',
      placeholderConfirmPass: 'Please enter your new password',
      required: 'This field is required',
      requiredPass: 'Password is required',
      minPass: 'Password must be at least 8 characters long',
      capitalLetter: 'Password must contain a capital letter',
      smallLetter: 'Password must contain a small letter',
      number: 'Password must contain a number',
      specialChar: 'Password must contain a special character',
      confirmed: 'Passwords do not match',
    },
  },
  form: {
    search: 'Search',
    filter: 'Filters',
    fileUpload: 'File Upload',
    save: 'Save',
    isSaving: 'Saving...',
  },
  table: {
    download: 'Download Report',
    file: 'Download as',
    empty: 'No data found',
    show: 'Show',
    fromItem: 'Item from',
  },
  user: {
    login: 'Login',
    logout: 'Logout',
    userSettings: 'User Settings',
    coinRani: 'Each coin Rani is equal to',
    coinIrq: ' Each coin  is equal to',
    rial: 'Rial',
    yes: 'Yes',
    no: 'No',
    confirm: 'Are you sure about leaving?',
    logoutTitle: 'Sign out of your account',
    loginDesc: 'Please enter your username and password',
    username: 'Username',
    password: 'Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    confirmPassBtn: 'Confirm',
    titleChangePass: 'Change Password',
    title2FA: '2FA Authentication',
    titleDisable2FA: 'Disable 2FA',
    btnConfirm2FA: 'Activate 2FA',
    btnDisable2FA: 'Disable 2FA',
    description2FA:
      'Scan the QR code below in the Google Authenticator app and enter the verification code. <br> Download from',
    descriptionDisable2FA:
      'Open the Google Authenticator app and enter the 6-digit code for your account.',
    downloadFrom: 'Download from',
    googlePlay: 'Google Play',
    appleStore: 'Apple Store',
  },
  campaign: {
    EditCampaign: {
      modalConfirm: {
        title: 'Unsaved Changes',
        description:
          'You are editing a campaign and there are unsaved changes. Are you sure you want to leave without saving?',
        saveAndContinue: 'Continue',
        leaveWithoutSave: 'Leave without saving',
      },
    },
    createCampaign: {
      modalConfirm: {
        title: 'Unsaved Changes',
        description:
          'You are creating a campaign and there are unsaved changes. Are you sure you want to leave without saving?',
      },
    },
    campaignPage: {
      box1: {
        title: 'Basic Information',
        name: 'Campaign Title',
        date: 'Campaign Date',
        modelCampaign: 'Campaign Type',
        calculation: 'Calculation Based On',
        baseScore: 'Base Score (for each purchase cycle)',
        userLimit: 'User Limit',
        unLimit: '(unlimited)',
        toolTipBaseScore:
          'In this section, you specify the base point. This point is awarded to the user when the purchase of the main product and complementary products (according to the defined conditions) is completed.',
        toolTipUserLimit:
          'In this section, you can determine the maximum number of times each user is allowed to receive the base points for this campaign. * If you enter the number (0), users will be able to receive points without restrictions.',
      },

      box2: {
        addProduct: 'Add Products',
        edit: 'Edit',
        product: 'Product',
        vahed: 'Unit',
        number: 'Number',
        addCategory: 'Add Category',
        category: 'Category',
        totalInvoice: 'Total Invoice (Rial)',
        modelPackaging: 'Category Type',
        mablagh: 'Amount (Rial)',
        minimumProduct: 'Minimum Product',
        minimumRow: 'Minimum number of rows the user must buy',
        modelProduct: 'Product Type',
        toolTipModelProduct:
          'In this section, you specify the type of each product: Core product: The user must purchase a certain number of this product to receive points. Complementary product: The product is optional; typically, not all complementary products need to be purchased to receive points.*** To complete a points cycle, the user must meet all defined conditions. These conditions may include only core products, only complementary products, or a combination of both — depending on your setup.',
        toolTipMinimum:
          'This section determines how many different complementary products the user must purchase to earn points. For example, if 10 complementary products are defined and you set the **Minimum complementary product value to 4, the user must purchase at least 4 different types of these 10 products to earn points.',
      },

      box3: {
        title: 'Score Ladder',
        addStairs: 'Add Score Ladder',
        edit: 'Edit',
        cycleNum: 'Cycle Number',
        ExtrScore: 'Extra Score',
        toolTipStairs:
          'In this section, you can define the points ladder. *** The points ladder determines how many additional points the user will receive after completing a number of purchase cycles. Example: If defined in the settings: Cycle 10 = 500 points, the user will receive 500 additional points in addition to the base points after completing 10 cycles.',
        toolTipCycle:
          'The number of cycles is the number of times a user must complete the purchase requirements to be eligible to receive additional points. Example: If the number of cycles is set to 10, the user must complete 10 purchases (main and complementary products).',
        toolTipExtraScore:
          'Bonus points are a reward that a user receives in addition to the base points after reaching a certain number of complete cycles. Example: For example, if the bonus points for cycle 10 are 500, the user will receive 500 bonus points after completing 10 cycles.',
      },

      box4: {
        title: 'Features',
        city: 'City/Representative',
        userClass: 'Customer Class',
        storeModel: 'Store Model',
        toolTipCity:
          'From this section, you can specify in which cities the campaign will be active.',
        toolTipUserClass:
          'From this section, you can determine which category or class of users the campaign will be active for.',
        toolTipStoreModel:
          'From this section, you can determine what types of stores the campaign will be active for.',
      },

      box5: {
        title: 'Additional Information',
        selectFile: 'Select File',
        showCampaign: 'Show Campaign',
        shortDesc: 'Short Description',
        fullDesc: 'Full Description',
      },
    },
  },
  dashboard: {
    summary: {
      title: 'Summary',
      totalCampaigns: 'Total Campaigns',
      totalUsers: 'Total Users',
      totalPointsEarned: 'Total Points Earned',
      totalPointsSpent: 'Total Points Spent',
    },
    summaryReport: {
      title: 'Summary Reports',
      topSalesCampaigns: 'Top Sales Campaigns',
      topCities: 'Top Cities',
      topUsers: 'Top Users',
    },
  },

  fileManager: {
    modalDetails: {
      title: 'File Details',
      notSelected: 'No file selected',
      name: 'File Name',
      createUpload: 'Create Upload',
      created: 'Created',
      size: 'Size',
      download: 'Download',
      moveTo: 'Move to',
      delete: 'Delete File',
    },

    mainFileManager: {
      title: 'File Manager',
      folders: 'Folders',
      files: 'Files',
      emptyFile: 'Empty File',
      descEmptyFile: 'No files or folders exist in this location',
    },

    cardFileManager: {
      edit: 'Edit',
      delete: 'Delete',
      move: 'Move',
    },

    headerFileManager: {
      newFile: 'New File',
      newFolder: 'New Folder',
      searchFile: 'Search',
      fileManager: 'File Manager',
      uploadDetail: {
        descUploadFile: 'Drag and drop your file here to upload',
        or: 'Or',
        select: 'Select',
        maxSize: 'Maximum file upload size',
        format: 'Allowed format',
        mb: 'MB',
      },
    },

    footerFileManager: {
      confirm: 'Confirm',
      moveTo: 'Move to',
      cancelMove: 'Cancel Move',
    },

    modalCreateFolder: {
      createFolder: 'Create New Folder',
      name: 'Folder Name',
      nameFile: 'File Name',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },

    modalEdit: {
      titleFolder: 'Edit Folder',
      titleFile: 'Edit File',
      confirm: 'Confirm',
      cancel: 'Cancel',
      message: 'This name already exists',
      folder: 'Folder',
      file: 'File',
    },

    modalDelete: {
      title1: 'Is it possible to delete an item',
      title2: 'are you sure?',
      yesDelete: 'Yes Delete',
      noDelete: 'No I want to cancel',
    },
  },

  RatioCoins: {
    title: 'Points rate conversion',
    coin: '   Each coin toss is equal to (rials):  ',
    submit: 'Conversion rate recording',
    modal: {
      title: 'Are you sure you want to make this change?',
      desc1:
        "When the points conversion rate changes, the value of all users' points is updated. This change affects users' credit calculations in the Customer Club.",
      desc2: 'Please make sure the information entered is correct before confirming.',
      cancel: 'Cancel/Return',
      yes: 'Confirm and apply changes',
    },
    what: 'In this table, you can specify how much Rial credit each coin is equivalent to.',
    toolTip: {
      success: {
        header: 'Success',
        body: 'The points conversion rate has been successfully changed',
      },
      error: {
        header: 'Error',
        body: 'The points conversion rate has not been changed',
      },
    },
  },
}
